import React, { useState } from 'react'
import Drawer from './commons/Drawer'
import { PiShoppingCartThin } from 'react-icons/pi';
import { IoMdClose } from 'react-icons/io';
import { CartDrawer } from './CartDrawer';
import { useSelector } from 'react-redux';
import { formatNumber, rateUsdt } from '../service';

export const CardButton = () => {
    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;
    const [open, setOpen] = useState(false);
    const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);
    return (
        <div>
            <button className="flex items-center gap-4" onClick={() => setOpen(true)}>
                <div className='flex items-center justify-center'>
                    <PiShoppingCartThin  className='text-2xl md:text-3xl' />
                    <span className='flex md:hidden items-center justify-center rounded-full w-[20px] h-[20px] bg-[--color-button-2] text-xs'>{cartItems?.length}</span>
                </div>
                <div className=' text-base hidden md:block items-center'>
                    <div className='flex items-center gap-1 '>cart <span className='flex items-center justify-center rounded-full w-[20px] h-[20px] bg-[--color-button-2] text-xs'>{cartItems?.length}</span></div>
                    <div className='font-bold hover:text-[--color-button-3] transition-all duration-150'>  <div className="flex gap-2 text-[--color-button-3]">
                  <img src="/images/logoToken.png" style={{ width: 20 }} /> {(Number(total)).toFixed(2)} <span className="text-black">({formatNumber(total * rateUsdt)}đ)</span>
                </div></div>
                </div>
            </button>
            <Drawer isOpen={open} onClose={() => setOpen(false)} width="w-96">
                <CartDrawer setOpen={setOpen}/>
            </Drawer>
        </div>
    )
}
